import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { environment } from '@env';

@Injectable({
  providedIn: 'root',
})
export class PriorityAppointmentApiProviderService {
  constructor(private apiService: ApiService) {}

  createPriorityAppointment(
    patientId: string,
    patientTagId: string,
    doctorId: string,
    specialtyId: number,
    isPresencial: boolean = true,
    medicalReferralTyper: number,
    requestedByUserId: string,
    externalAppointmentId: string,
  ) {
    return this.apiService.post(`${environment.environmentVariables.apiCoreUrl}/Requisition/match`, {
      patient_id: patientId,
      speciality_id: specialtyId,
      is_presencial: isPresencial,
      profile_tag_id: patientTagId,
      doctor_id: doctorId,
      medical_referral_type: medicalReferralTyper,
      requested_by_user_id: requestedByUserId,
      external_appointment_id: externalAppointmentId,
    });
  }
}
